module.exports = __webpack_public_path__ + "img/Gruppenführer.9baceb60.svg";